import {
  useMenuItem
} from "../__chunks/XADDW7ND.js";
import "../__chunks/W7JXAQKF.js";
import {
  MenuContext,
  MenuItemCheckedContext
} from "../__chunks/HVBRRKV4.js";
import "../__chunks/W5P7IKOU.js";
import {
  useRadio
} from "../__chunks/UVKFBOMX.js";
import "../__chunks/6I2PARRP.js";
import "../__chunks/FVD2NJZN.js";
import "../__chunks/P4RGQGTG.js";
import "../__chunks/VFNGSUSF.js";
import "../__chunks/T3DJZG63.js";
import "../__chunks/OXPV2NBK.js";
import "../__chunks/WJ37OVG2.js";
import "../__chunks/MYID4V27.js";
import "../__chunks/BMLNRUFQ.js";
import {
  createElement,
  createHook,
  createMemoComponent
} from "../__chunks/NQJBHION.js";
import "../__chunks/P63NRZ4A.js";
import {
  useWrapElement
} from "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/menu/menu-item-radio.tsx
import { useContext } from "react";
import { invariant } from "@ariakit/core/utils/misc";
import { jsx } from "react/jsx-runtime";
var useMenuItemRadio = createHook(
  (_a) => {
    var _b = _a, {
      store,
      name,
      value,
      checked,
      onChange: onChangeProp,
      hideOnClick = false
    } = _b, props = __objRest(_b, [
      "store",
      "name",
      "value",
      "checked",
      "onChange",
      "hideOnClick"
    ]);
    const context = useContext(MenuContext);
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "MenuItemRadio must be wrapped in a MenuList or Menu component"
    );
    const isChecked = store.useState(
      (state) => checked != null ? checked : state.values[name] === value
    );
    props = useWrapElement(
      props,
      (element) => /* @__PURE__ */ jsx(MenuItemCheckedContext.Provider, { value: !!isChecked, children: element }),
      [isChecked]
    );
    props = __spreadValues({
      role: "menuitemradio"
    }, props);
    props = useRadio(__spreadValues({
      value,
      checked: isChecked,
      onChange: (event) => {
        onChangeProp == null ? void 0 : onChangeProp(event);
        if (event.defaultPrevented)
          return;
        store == null ? void 0 : store.setValue(name, value);
      }
    }, props));
    props = useMenuItem(__spreadValues({ store, hideOnClick }, props));
    return props;
  }
);
var MenuItemRadio = createMemoComponent(
  (props) => {
    const htmlProps = useMenuItemRadio(props);
    return createElement("div", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  MenuItemRadio.displayName = "MenuItemRadio";
}
export {
  MenuItemRadio,
  useMenuItemRadio
};
